import React from 'react';
import { format } from "date-fns";
import { Link } from 'react-router-dom';
import './styles.scss';

const UnitFeed = ({ UnitHistory, News }) => {

    if (!UnitHistory) return null;

    return (
        <section className="unit-feed">
            <div className="unit-feed__wrapper">
                <div className="unit-feed__content">
                    {(UnitHistory && UnitHistory.length > 0) &&
                        <div className="unit-feed__col unit-feed__col--alerts">
                            <h2 className="unit-feed__heading">Händelser för enheten</h2>
                            <ul className="unit-feed__feed">
                                {UnitHistory.map((log, i) => {
                                return (
                                        <li key={`log${i}`}>
                                            <div className="unit-feed__feed-date">{new Date(log.logDate).toLocaleDateString('sv')}</div>
                                            <div className="unit-feed__feed-text">
                                                {log.description}
                                            </div>
                                        </li>
                                ); 
                                })}
                            </ul>
                        </div>
                    }
                    {(News && News.news.length > 0) &&
                        <div className="unit-feed__col unit-feed__col--news-col">
                            <h2 className="unit-feed__heading">Relaterade nyheter</h2>
                            <ul className="unit-feed__feed">
                                {News.news.map(item => {
                                    return (
                                        <li key={item.newsId}>
                                            <div className="unit-feed__feed-date">{format(new Date(item.publishedOn),'yyyy-MM-dd')}</div>
                                            <div className="unit-feed__feed-text">
                                                <Link to={`/news/${item.slug}`}>{item.header}</Link>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                            <Link className="unit-feed__news-link" to="/news">Alla nyheter</Link>
                        </div>
                    }
                </div>
            </div>
        </section>
    );
};

export default UnitFeed;